import React, { FC } from 'react';
import './signup_user.scss';
import { SignUpDiscovery } from './discovery/SignUpDiscovery';
import { SignUpForm } from './form/SignUpForm';
import { PageContainer } from '../../../components/page-container/PageContainer';
import { Page } from '../../../components/page/Page';
import { SignUpLayout } from './SignUpLayout';
import { Testimonials } from '../../../presentation/testimonials/Testimonials';
import { SearchDifferent } from '../../../presentation/SearchDifferent';
import {
  KeyInformation,
  WinningStrategy,
  TailoredSearch,
} from '../../../presentation/presentation-banner';
import { PricingBanner } from './pricing-banner/PricingBanner';

export const SignUpUserFromCampaign: FC = () => (
  <SignUpLayout>
    <PageContainer classNames="signup-user">
      <Page>
        <div className="signup-user__discovery">
          <SignUpDiscovery />
        </div>
        <div className="signup-user__form">
          <SignUpForm />
        </div>
      </Page>
    </PageContainer>
    <Testimonials />
    <SearchDifferent />
    <KeyInformation />
    <WinningStrategy />
    <TailoredSearch />
    <PricingBanner />
  </SignUpLayout>
);
